import type { ChatMessage } from '@/types/chat'

interface ChatMessageListProps {
  messages: ChatMessage[]
}

export function ChatMessageList({ messages }: ChatMessageListProps) {
  if (messages.length === 0) {
    return (
      <div className="flex flex-1 items-center justify-center p-6 text-sm text-muted-foreground" data-testid="chat-message-list">
        Send a prompt to start the conversation.
      </div>
    )
  }

  return (
    <div className="flex-1 space-y-4 overflow-auto p-4" data-testid="chat-message-list">
      {messages.map((message) => (
        <article key={message.id} className="space-y-2" data-testid={`chat-message-${message.id}`}>
          <div
            className="rounded-lg border border-border bg-muted/40 p-3"
            data-testid={`chat-user-message-${message.id}`}
          >
            <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">User</p>
            <p className="mt-1 whitespace-pre-wrap text-sm">{message.promptText}</p>
            <p className="mt-2 font-mono text-[11px] text-muted-foreground" data-testid="chat-settings-badge">
              {message.settingsBadge}
            </p>
          </div>

          {message.response ? (
            <div
              className="rounded-lg border border-border bg-card p-3"
              data-testid={`chat-assistant-message-${message.id}`}
            >
              <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">Assistant</p>
              <p className="mt-1 whitespace-pre-wrap text-sm">
                {message.response.normalizedText}
                {message.response.status === 'streaming' ? (
                  <span className="ml-0.5 inline-block animate-pulse" data-testid="chat-streaming-cursor">
                    |
                  </span>
                ) : null}
              </p>
              <p className="mt-2 text-xs text-muted-foreground" data-testid="chat-cost-latency">
                {message.response.tokensInput} in / {message.response.tokensOutput} out · ~$
                {message.response.estimatedCost.toFixed(6)} · {message.response.latencyMs}ms
              </p>
            </div>
          ) : null}
        </article>
      ))}
    </div>
  )
}
